import React, { useEffect, useState } from 'react';
import '../../assets/css/Podcast.css'
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import InnerHeaderContent from '../../Components/Header/InnerHeaderContent';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { GetPodCastbyClickApi, PodcastGet, SinglePodcastApi } from '../../Redux/Auth/Auth_Action';
import { toast } from 'react-toastify';

const SinglePodcast = () => {


    let paramData = useParams();
    const dispatch = useDispatch();
    // const location = useLocation();
    // let navigate = useNavigate();

    const [state, setState] = useState({ stateData: [] });
    const [podcast, setPodcast] = useState({ podcastData: [] });



    const SinglePodcast = () => {
        dispatch(SinglePodcastApi(paramData))
            .then((res) => {
                // console.log("res from single podcast action", res);
                setState({ ...state, stateData: res.data.response.data.data })
            })
            .catch((e) => {
                console.log('error from action', e);
                toast.error("Network Error");
            })

    }

    const GetPodCastbyClick = (e) => {
        // console.log(e, 'from single podcast')
        dispatch(GetPodCastbyClickApi(e))
            .then((res) => {
                // console.log("res from single podcast action", res);
                setState({ ...state, stateData: res.data.response.data.data })
            })
            .catch((e) => {
                console.log('error from action', e);
                toast.error("network error");
            })
    }

    const PodcastGetAll = () => {
        dispatch(PodcastGet())
            .then((res) => {
                // console.log("res from blog all podcast", res.data);
                setPodcast({ ...podcast, podcastData: res.data });
            })
            .catch((e) => {
                console.log("res from blog all podcast", e);
                toast.error("Network Error");
            })
    }
    useEffect(() => {
        SinglePodcast();
        PodcastGetAll();
    }, []);

    useEffect(() => {
        window.scroll(0, 0);
    }, [])

    // console.log(state?.stateData[0]);

    return (
        <div className='tips_page'>
            <section className='reamining_header_background pos-rel'>
                <Header />
                <InnerHeaderContent pageName={"PODCAST"} />
            </section>
            <section className='podcast single-podcast-padding'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12 mt-5'>
                            {
                                (state?.stateData[0]?.media_url.slice(-3) === "mp4")
                                    ?
                                    <video width="100%" height="300" controls controlsList="nodownload" >
                                        <source src={`${state?.stateData[0]?.media_url}`} type="video/mp4" />
                                    </video>
                                    :
                                    <img src={state?.stateData[0]?.media_url} className="main_podcast" alt="pocast_main" />
                            }
                            <p className='f-mon-light f-15 mt-3'>
                                {/* {state?.stateData[0]?.created_at?.slice(0, 10)} */}
                                <span className='ml-1'>{state?.stateData[0]?.created_at?.slice(5, 7)}</span>
                                <span>{state?.stateData[0]?.created_at?.slice(7, 10)}</span>
                                <span>-{state?.stateData[0]?.created_at?.slice(0, 4)}</span>
                            </p>
                            <p className='f-mon-reg f-25 mb-5 txt-dngrs' >{state?.stateData[0]?.title} </p>
                            <div className='f-mon-reg f-15 mb-5 txt-dngrs brkbrk ' dangerouslySetInnerHTML={{ __html: state?.stateData[0]?.description }}>

                            </div>

                            <p className='mt-10 f-mon-bold f-35 mb-5'>YOU MAY LIKE</p>
                            <div className='row'>
                                {podcast?.podcastData?.slice(0, 3).map((item, index) => {
                                    console.log(item);
                                    return (
                                        <div onClick={() => { GetPodCastbyClick(item.id) }} key={index} className='col-lg-4'>
                                            <div className="cursor_pointer" >

                                                {(item.media_url.slice(-3) === "mp4")
                                                    ?
                                                    <video className="podcast_small_images" controlsList="nodownload" autoPlay loop muted >
                                                        <source src={`${item?.media_url}`} type="video/mp4" />
                                                    </video> :
                                                    <img src={item?.media_url} className="podcast_small_images" />
                                                }
                                                {/* <img src={item?.media_url}  /> */}
                                                <p className='f-mon-light f-15 mb-1 mt-3 text-white'>{item?.created_at?.slice(0, 10)}</p>
                                                <p className='f-mon-reg f-15 text-white'>{item.title}</p>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default SinglePodcast;